import React from 'react'

const SelectInputWrapper = React.forwardRef((props, ref) => (
  <div className='form-group row'>
    <label className='facility-label col-lg-5'>{props.label}</label>
    <div className='col-lg-7'>
      <select
        className='form-control'
        defaultValue={props.defaultValue}
        name={props.name}
        ref={ref}
        onChange={props.onChange}
      >
        { props.options.map((option, i) => {
          return <option key={i} value={option}>{option}</option>
        })}
      </select>
    </div>
  </div>
))

export default SelectInputWrapper
